export default {
  namespaced: true,
  state: {
    all: [],
    loading: false
  },
  getters: {
    all: (state) => state.all,
    find: (state) => state.all.find((discipline) => discipline.id == Vue.$route.params.id),
    loading: (state) => state.loading
  },
  mutations: {
    startLoading(state) {
      state.loading = true
    },
    stopLoading(state) {
      state.loading = false
    },
    setAll(state, disciplines) {
      state.all = disciplines
      state.loading = false
    },
    set(state, discipline) {
      state.all = state.all.filter((o) => o.id != discipline.id)
      state.all.push(discipline)
    },
    remove(state, id) {
      state.all = state.all.filter((o) => o.id != id)
    }
  },
  actions: {
    fetchAll({ commit }) {
      this.$authorize('list', 'Discipline')

      commit('startLoading')
      return Vue.$http.get('admin/disciplines').then(
        (response) => commit('setAll', response.data),
        (response) => commit('stopLoading')
      )
    },
    fetch({ commit }, id) {
      this.$authorize('read', 'Discipline')

      return Vue.$http.get(`admin/disciplines/${id}`).then(
        (response) => commit('set', response.data)
      )
    },
    create({ commit }, discipline) {
      this.$authorize('create', 'Discipline')

      return Vue.$http.post('admin/disciplines', { discipline }).then(
        response => commit('set', response.data)
      )
    },
    update({ commit }, discipline) {
      this.$authorize('edit', 'Discipline')

      return Vue.$http.patch(`admin/disciplines/${discipline.id}`, { discipline })
        .then(response => commit('set', response.data),)
        .catch(error => commit('set', Object.assign(discipline, error.response.data)))
    },
    destroy({ commit }, id) {
      this.$authorize('delete', 'Discipline')

      return Vue.$http.delete(`admin/discipline/${id}`).then(
        (response) => commit('remove', id)
      )
    }
  }
}
